

import { Container } from 'inversify';
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { IampSearchConfig } from '../../../../builderMaster/user/domain/iampSearchConfig';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import { IServiceSearchConfig } from '../../../../builderMaster/user/application/IServiceSearchConfig';
import { TYPES } from '../../../../../common/domain/types';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import { MessageService } from '../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';

export default defineComponent({
    name: 'savesearch',
    props: {
          container: {
            type: Object as () => Container            
        }, 
        applicationId: {
            type: Number,
            default: -1
        },

        applicationVersion: {
            type: Number,
            default: -1
        },
        componentId: {
            type: Number,
            default: -1
        },
        dataFilter: Object,
        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        },
        catalogosData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },
    },
    emits: ['click:setSearch'],
    setup(props, { emit }) {
        const store = useStore();
        const submitted = ref(false);
        const showAdd = ref(false);
        const data = ref<IampSearchConfig>({
            userId: store.getters.getCurrentUser.id,
            applicationId: props.applicationId,
            applicationVersion: props.applicationVersion,
            componentId: props.componentId,
            profileId: store.getters.getCurrentProfile,
            name: '',
            data: JSON.stringify(props.dataFilter?.map(x => ({
                filter: x.filter, value: x.value, fieldId: x.field.id, dataSourceId: x.field.dataSourceId,
                valueList: x.valueList, valueBool: x.valueBool,valueNumber: x.valueNumber,
                valueDateTime: x.valueDateTime ,rangeValue: x.rangeValue, rangeNumber: x.rangeNumber,
                rangeDateTime: x.rangeDateTime

            }))),
            fcr: new Date()
        });

        const dataSearch = ref<IampSearchConfig[]>();

        const includeCurrentProfile = ref(false)

        const reglas = {
            name: {
                required: helpers.withMessage("El nombre es obligatorio", required),
            },
        }





        const v$ = useVuelidate(reglas, data as any);

        const isValidData = (): boolean => {
            submitted.value = true;
            v$.value.$reset();
            v$.value.$touch();
            if (v$.value.$invalid) {
                HelperCommon.setFocusOnFirstError();
                return false;
            }

            return true;
        }


        const saveData = () => {
            if (isValidData()) {
                data.value.profileId = includeCurrentProfile.value ? store.getters.getCurrentProfile : null

                if (props.container) {
                    let dataInput = JSON.parse(JSON.stringify(data.value));
                    const _srv = props.container.get<IServiceSearchConfig>(
                        TYPES.SEARCH_USR_REPOSITORY
                    );
                    HelperLoading.showSaving();
                    _srv.add(dataInput as any)
                        .then((response) => {
                            dataSearch.value?.unshift(response)
                        })
                        .finally(() => {
                            HelperLoading.hideSaving();
                            showAdd.value = false
                        });
                }

            }
        }

        const loadData = () => {
            if (props.container) {
                const _srv = props.container.get<IServiceSearchConfig>(
                    TYPES.SEARCH_USR_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.getByAllByUserId(store.getters.getCurrentUser.id, props.applicationId, props.applicationVersion, props.componentId)
                    .then((response) => {                        
                        dataSearch.value = response.sort((a, b) => { return +new Date(b.fcr) - +new Date(a.fcr) })
                    })
                    .finally(() => {
                        HelperLoading.hideLoading();
                    });
            }
        }

        const formatData = (data: IampSearchConfig) => {

            const savedData = JSON.parse(data.data) as any
            var output = new Array<string>();

            savedData.forEach((item: { filter: string; fieldId: string; value: any; }) => {
                let criteria = props.catalogosData.find(x => x.id == item.filter)?.description ?? item.filter
                const field = props.compDataSource.dataSource.iapDataSourceFields.find(x => x.id == item.fieldId)
                const fieldDescription = (field?.field ?? field?.shortDescription) ?? item.fieldId
                let  value = (item.value ?? '')
                if (item['rangeDateTime']){
                    criteria ='';
                    const from = HelperCommon.formateaFecha(item['rangeDateTime']['from'])
                    const to = HelperCommon.formateaFecha(item['rangeDateTime']['to'])
                    if (from){
                        value = ' Desde: ' + from
                    }
                    if (to){
                        value += ' Hasta: ' + to
                    }
                }
                output.push('<b>' + fieldDescription + '</b> ' + criteria + ' ' + value)
            });
            return output.join('</br>')
        }

        const deleteSearch = (data:IampSearchConfig) =>{

            var doCallbackOk = () => {
                if (props.container) {
                const _srv = props.container.get<IServiceSearchConfig>(
                    TYPES.SEARCH_USR_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.delete(data.userId, data.applicationId, data.applicationVersion, data.componentId,data.name)
                    .then((response) => {
                        if (response){
                        dataSearch.value = dataSearch.value?.filter(x=> 
                        x.applicationId !== data.applicationId
                        && x.applicationVersion !== data.applicationVersion
                        && x.componentId !== data.componentId
                        && x.userId !== data.userId
                        && x.name !== data.name
                        )

                        MessageService.showToast(MessageType.Correcto, "", 'Registro eliminado correctamente.');

                        }
                    })
                    .finally(() => {
                        HelperLoading.hideLoading();
                    });
            }

            }

            MessageService.showMessage(MessageType.Pregunta, '', '¿Eliminar búsqueda "' + data.name + '" ?', true, true, false, '', doCallbackOk, null);
        }

        onMounted(() => {
            //getTables();  
            loadData()
            //Catalog(CatalogTypeConst.FILTROBUSQUEDA)          
        });

        return {
            v$,
            submitted,
            saveData,
            data,
            includeCurrentProfile,
            dataSearch,
            showAdd,
            formatData,
            deleteSearch

        };
    },
});
